import Colors from '@/constants/Colors';
import { StyledAnswerFeedback } from './AnswerFeedback.styled';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
export default function AnswerFeedback({
  allAnswered,
  allCorrect,
  correct,
  className,
}) {
  return (
    <StyledAnswerFeedback
      className={`${className} ${correct ? 'correct' : 'incorrect'}`}
    >
      <div className={`feedback-icon ${allAnswered ? '' : 'hidden'}`}>
        {allCorrect ? (
          correct ? (
            <CheckOutlined style={{ color: Colors.green }} />
          ) : (
            ''
          )
        ) : correct ? (
          <CheckOutlined style={{ color: Colors.green }} />
        ) : (
          <CloseOutlined style={{ color: Colors.red }} />
        )}
      </div>
    </StyledAnswerFeedback>
  );
}
